import { onBeforeMount, onBeforeUnmount } from 'vue';

/**
 * Composable pour disable the increment/decrement avec le scroll
 * sur les inputs = number
 */
export default () => {
    const disableScrollOnNumberInputs = (event: WheelEvent | Event) => {
        const target = event.target as HTMLElement;

        // Vérifier si l'élément est un input de type number et qu'il a le focus
        if (target && target.tagName === 'INPUT') {
            const input = target as HTMLInputElement;
            if (input.type === 'number' && document.activeElement === input) {
                // Empêcher le comportement par défaut du scroll
                event.preventDefault();
            }
        }
    };

    onBeforeMount(() => {
        // Ajouter l'event listener avec l'option passive: false pour pouvoir utiliser preventDefault
        // capture: true pour intercepter l'event avant qu'il n'atteigne l'input
        document.addEventListener('wheel', disableScrollOnNumberInputs, { passive: false, capture: true });
        // Handle event pour les navigateurs qui utilisent 'mousewheel' (IE ETC ETC TMTC)
        document.addEventListener('mousewheel', disableScrollOnNumberInputs, { passive: false, capture: true });
    });

    onBeforeUnmount(() => {
        // Remove the event listeners
        document.removeEventListener('wheel', disableScrollOnNumberInputs);
        document.removeEventListener('mousewheel', disableScrollOnNumberInputs);
    });
};
